import {
  type DeviceSettings,
  useDeviceSetting,
} from "@-/dev.improve.haniverse.lib.device-settings";

/** A Browse → Levels pack sheet surface that collapses to its header. */
export type LevelsPackSurface = DeviceSettings["collapsedLevelsPackSurfaces"][number];

/** Whether a pack sheet surface shows its body, remembered on the device across sheet remounts. */
export function useLevelsPackSurfaceExpanded(
  surface: LevelsPackSurface,
): [boolean, (isExpanded: boolean) => void] {
  const [collapsedSurfaces, setCollapsedSurfaces] = useDeviceSetting("collapsedLevelsPackSurfaces");
  const setIsExpanded = (isExpanded: boolean) => {
    const otherSurfaces = collapsedSurfaces.filter((collapsed) => collapsed !== surface);
    setCollapsedSurfaces(isExpanded ? otherSurfaces : [...otherSurfaces, surface]);
  };
  return [!collapsedSurfaces.includes(surface), setIsExpanded];
}
